module.exports = __webpack_public_path__ + "img/lj.20489e2a.jpg";